import { render, staticRenderFns } from "./AgentInfoComp.vue?vue&type=template&id=36e33cde&scoped=true&"
import script from "./AgentInfoComp.vue?vue&type=script&lang=js&"
export * from "./AgentInfoComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e33cde",
  null
  
)

export default component.exports